"use client";

import { useEffect, useState } from "react";
import { Media, WaveBgColor } from "../../../global";
import BottomCurves from "../curves/bottomCurves";
import NewsTab from "./newsTab";
import NewsItems from "./newsItems";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import RevealElement from "../revealElement";
import TabDropdown from "../ui/tabDropdown";
import { slugify } from "@/utils/api-helpers";

interface NewsProps {
    news: {
        newsTab: {
            name: string;
        }[];
        news: {
            data: {
                attributes: {
                    date: string;
                    title: string;
                    tag: string;
                    image: Media;
                };
            }[];
        };
        waveBgColor: WaveBgColor;
    };
}

export default function News({ data }: { data: NewsProps }) {
    const [selectedTab, setSelectedTab] = useState("All");

    const handleClick = (tabName: string) => {
        setSelectedTab(tabName);
        const formatted = slugify(tabName);
        const url = new URL(window.location.href);
        url.searchParams.set("tab", formatted);
        window.history.pushState({}, "", url);
    };

    useEffect(() => {
        const queryTab = slugify(
            new URLSearchParams(window.location.search).get("tab") || ""
        );
        const availableTabs = [
            "all",
            ...data.news.newsTab.map((tab: any) => tab.name.toLowerCase()),
        ];
        if (availableTabs.includes(queryTab)) {
            setSelectedTab(
                data.news.newsTab.find(
                    (tab: any) => tab.name.toLowerCase() === queryTab
                )?.name || "All"
            );
        }
    }, [data.news.newsTab]);

    return (
        <section className="bg-lightGrey pb-12 md:pb-32 xl:pb-52 pt-[6.333vw] xl:pt-[1.333vw] px-8 xl:px-[10.625vw]">
            <RevealElement>
                <div className=" flex flex-col items-center space-y-8 overflow-visible">
                    {/* Mobile Tab */}
                    <TabDropdown
                        tabs={[...data.news.newsTab.map((tab) => tab.name)]}
                        selectedTab={selectedTab}
                        onTabChange={handleClick}
                    />

                    {/* Desktop Tab */}
                    <div className="hidden lg:flex overflow-x-auto whitespace-nowrap scrollbar-hide w-full -mx-4 space-x-2 md:space-x-4 md:justify-center">
                        {data.news.newsTab.map((tab: any, index: number) => (
                            <div key={`tab-${index}`}>
                                <NewsTab
                                    name={tab.name}
                                    selectedTab={selectedTab}
                                    onClick={() => handleClick(tab.name)}
                                />
                            </div>
                        ))}
                    </div>

                    <TransitionGroup>
                        <CSSTransition
                            key={selectedTab}
                            timeout={500}
                            classNames="fade"
                        >
                            <NewsItems tag={selectedTab} />
                        </CSSTransition>
                    </TransitionGroup>
                </div>
            </RevealElement>
            <BottomCurves
                direction="right"
                color={data.news.waveBgColor.waveBgColor}
            />
        </section>
    );
}
